import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import dummyData from '../data.json';
import { useSelector } from 'react-redux';

const CustomerEngagementChart = () => {
  const [engagementData, setEngagementData] = useState({});
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const currentDate = useSelector((state) => state.customization.currentDate);

  const formatDate = (date) => {
    if (!date) return '';
        // Check if date is already a string or if it's a Date object
    if (typeof date === 'string') {
      return date;
    }

    // Check if it's a valid Date object
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are 0-indexed
    const year = date.getFullYear().toString().slice(-2); // Get last 2 digits (25)
    return `${day}-${month}-${year}`;
  };

  const formattedDate = formatDate(currentDate);

  useEffect(() => {
    if (formattedDate === '29-4-25') {
      const data = dummyData.customerProductEngagement || {};
      setEngagementData(data);
      setIsDataAvailable(data.zones && Object.keys(data.zones).length > 0);
    } else {
      setEngagementData({});
      setIsDataAvailable(false);
    }
  }, [formattedDate]);

  if (!currentDate) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '8px'
      }}>
        <p style={{ color: '#6c757d', fontSize: '16px' }}>Please select a date to view engagement data</p>
      </div>
    );
  }

  if (!isDataAvailable) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '8px'
      }}>
        <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '8px' }}>
           No Integrations Found
        </p>
       
      </div>
    );
  }

  const zones = engagementData.zones;
  const categories = Object.keys(zones);

  const seriesData = ['Viewed', 'Touched', 'Compaired', 'Picked'].map((key) => ({
    name: key,
    data: categories.map((zone) => zones[zone][key] || 0),
  }));

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    xaxis: {
      categories,
      title: {
        text: 'Departments',
      },
    },
    yaxis: {
      title: {
        text: 'Customer Interactions Count',
      },
    },
    stroke: {
      show: true,
      width: 6,
      colors: ['transparent'],
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 7,
        borderRadiusApplication: 'end',
        columnWidth: '55%',
        barGap: 10,
      },
    },
    colors: ['#329242', '#44BE54', '#76D183', '#A8E4B1'],
    dataLabels: { enabled: false },
    legend: {
      position: 'top',
    },
    noData: {
      text: 'No data available',
      align: 'center',
      verticalAlign: 'middle',
      style: {
        color: '#6c757d',
        fontSize: '16px'
      }
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px' }}>
      <Chart options={chartOptions} series={seriesData} type="bar" height={480} width="100%" />
    </div>
  );
};

export default CustomerEngagementChart;